// Module
var code = `<div class="procedure_widget">
    <!-- ko if: allowAddProcedures -->
    <div class="add_procedure_section">
        <!-- ko if: currentProcedures !== undefined -->
        <span class="add_procedure_link" data-bind="click: toggleShowAddProcedureSection">
            <span class="icon_button only_icon_img" data-bind="css: {'icon_single_down_arrow_bold': showAddProcedureSection,
                                   'icon_add': !showAddProcedureSection()}"></span>
            <span class="add_procedure_label" data-bind="text: translated('Add procedure')"></span>
        </span>
        <!-- /ko -->

        <!-- ko if: currentProcedures === undefined || showAddProcedureSection() -->
        <div data-bind="css: {for_qs: quickSelectActionId}">
            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <label class="tw:w-36 tw:pt-0.5" for="procedure_id" data-bind="text: procedureLabel + ':',
                                  attr: {for: quickSelectActionId}"></label>
                <div class="tw:w-9/12">
                    <span class="tw:w-full">
                        <ko-selectem data-bind="css: {invalid_data: procedureId.isInvalid}" params="groupKey: null,
                                             labelKey: 'name',
                                             serializeKey: 'id',
                                             serialize: procedureId,
                                             id: 'procedure_id',
                                             deserialize: procedureId,
                                             options: availableProcedures,
                                             caption: translated('Please select a procedure')"></ko-selectem>
                        <!-- ko if: procedureHint -->
                        <p data-bind="text: '(' + procedureHint + ')'" class="padding_5"></p>
                        <!-- /ko -->
                    </span>
                </div>
            </div>

            <div class="tw:flex tw:gap-0.5 tw:items-center tw:py-0.5">
                <label for="procedure_date" class="tw:w-36" data-bind="text: translated('Date') + ':'"></label>
                <div class="tw:w-9/12 tw:flex tw:items-center tw:gap-0.5">
                    <ko-calendar-popup params="value: procedureDate,
                                               valueUpdate: 'input',
                                               id: 'procedure_date',
                                               name: repeatedProceduresVisible() ? undefined : 'procedure_date',
                                               class: 'width_100',
                                               css: {invalid_data: procedureDate.isInvalid},
                                               options: {maxDate: maxDate}"></ko-calendar-popup>

                    <input type="checkbox" id="procedure-repeat-multiple" class="tw:ms-1" data-bind="checked: repeatedProceduresVisible">
                    <label for="procedure-repeat-multiple" data-bind="text: translated('Apply procedure multiple times')"></label>
                </div>
            </div>


            <div class="tw:flex tw:gap-0.5 tw:items-center tw:py-0.5" data-bind="visible: repeatedProceduresVisible">
                 <div class="tw:w-36"></div>
                 <div class="tw:w-9/12">
                    <ko-repeated-instances params="startDate: procedureDate.isValid() ? procedureDate : undefined,
                                                   repetitionDatesDescription: translated('This will add the procedure %s times with the following dates'),
                                                   repetitionDatesNameAttribute: repetitionDatesNameAttribute,
                                                   repetitionDates: repetitionDates,
                                                   maxDate: maxDate,
                                                   isInvalidDateCallback: canAssignFutureDate"></ko-repeated-instances>
                    <!-- ko if: errorMessage -->
                        <div class="error tw:pt-2" data-bind="text: errorMessage"></div>
                    <!-- /ko -->
                </div>
            </div>

            <div class="tw:flex tw:gap-0.5 tw:py-0.5 tw:items-center">
                <label for="procedure-classification" class="tw:w-36 tw:pt-0.5" data-bind="text: translated('License') + ' / ' + translated('Classification') + ':'"></label>
                <select class="tw:w-9/12" id="procedure-classification" data-bind="options: availableClassifications,
                                   optionsCaption: translated('None'),
                                   optionsText: function(v) { return v.license_number + ': ' + v.classification_name; },
                                   optionsValue: 'classification_id',
                                   value: classificationId"></select>
            </div>

            <!-- ko if: availableUsers?.length -->
            <div class="tw:flex tw:gap-0.5 tw:py-0.5 tw:items-center">
                <label for="procedure-executing-user" class="tw:w-36 tw:pt-0.5" data-bind="text: translated('Executed by') + ':'"></label>
                <select class="tw:w-9/12" id="procedure-executing-user" data-bind="options: availableUsers,
                                   optionsCaption: translated('Current user'),
                                   optionsText: 'name',
                                   optionsValue: 'id',
                                   value: executingUser"></select>
            </div>
            <!-- /ko -->

            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <label for="procedure-comments" class="tw:w-36 tw:pt-0.5 nowrap" data-bind="text: translated('Comments') + ':'"></label>
                <textarea rows="4" class="tw:w-9/12" id="procedure-comments" data-bind="value: comment"></textarea>
            </div>

            <!-- ko if: applyDrugVisible -->
            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <div class="tw:w-36 tw:flex tw:gap-0.5 tw:items-center">
                    <input type="checkbox" id="procedure-apply-drug" value="1" data-bind="checked: applyDrugSelected">
                    <label for="procedure-apply-drug" data-bind="text: translated('Apply drug')"></label>
                </div>
                <label for="procedure-drug" class="tw:sr-only"></label>
                <select class="tw:w-9/12" id="procedure-drug" data-bind="css: {invalid_data: drugId.isInvalid},
                                   disable: availableDrugs.inProgress,
                                   options: availableDrugs,
                                   optionsCaption: translated('None'),
                                   optionsText: 'name',
                                   optionsValue: 'id',
                                   value: drugId,
                                   visible: !availableDrugs.inProgress()"></select>

                <label class="tw:sr-only" for="procedure-drug-loading"></label>
                <input type="text" class="tw:w-9/12" disabled="disabled" id="procedure-drug-loading" data-bind="value: translated('Loading') + ' ...',
                                  visible: availableDrugs.inProgress">
            </div>
            <!-- /ko -->

            <!-- ko if: applyDrugSelected -->
            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <label class="tw:w-36 tw:pt-0.5 nowrap" data-bind="text: translated('Drug package') + ':'"></label>

                <div class="tw:w-9/12">
                    <ko-selectem params="caption: translated('None'),
                                         css: {invalid_data: drugPackageId.isInvalid},
                                         disabled: availableDrugPackages.inProgress,
                                         groupKey: 'group',
                                         groupLabels: {available: translated('Available'),
                                                       outdated: translated('Outdated'),
                                                       __nogroup__: null},
                                         groupOrder: ['available', 'outdated'],
                                         labelKey: 'drug_package_number_with_quantity_and_register',
                                         options: availableDrugPackages,
                                         serialize: drugPackageId,
                                         serializeKey: 'drug_package_id'" data-bind="css: {invalid_data: drugPackageId.isInvalid},
                                            visible: !availableDrugPackages.inProgress()"></ko-selectem>

                    <label class="hidden" for="procedure-drug-package-loading"></label>
                    <input type="text" class="width_full" disabled="disabled" id="procedure-drug-package-loading" data-bind="value: translated('Loading') + ' ...',
                                      visible: availableDrugPackages.inProgress">
                </div>
            </div>
            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <label class="tw:w-36 tw:pt-0.5" data-bind="text: translated('Drug quantity: Quantity') + ':'"></label>
                <div class="tw:w-9/12">
                    <div class="tw:min-h-4 tw:max-h-36 tw:overflow-y-auto tw:border tw:border-shade-color-74 tw:p-1 tw:bg-white tw:rounded-xs tw:mb-1">
                        <table class="tw:text-left">
                            <tbody data-bind="foreach: subjects">
                            <tr>
                                <td>
                                    <input type="number" class="tw:w-32" aria-label="Drug quantity" min="0" data-bind="css: {invalid_data: drugQuantityApplied.isInvalid},
                                                      textInput: drugQuantityApplied">
                                </td>
                                <td>
                                    <span class="tw:p-1" data-bind="text: \$parent.drugUnit"></span>
                                </td>
                                <!-- ko if: "tank_id" in \$data -->
                                <td class="tw:w-full tw:p-1" data-bind="text: '#' + tank_id"></td>
                                <!-- /ko -->
                                <!-- ko if: "eartag_or_id" in \$data -->
                                <td class="tw:w-full tw:p-1" data-bind="text: eartag_or_id"></td>
                                <!-- /ko -->
                            </tr>
                            </tbody>
                            <!-- ko if: subjects.length > 1 -->
                            <tfoot>
                                <tr>
                                    <td class="tw:pt-2 tw:ps-2 tw:pb-1 tw:border-b-4 tw:border-double tw:border-main-color-dark">
                                        <!-- ko text: subjects.reduce((acc, subject) => acc + subject.drugQuantityApplied(), 0) --><!-- /ko -->
                                        <!-- ko text: drugUnit() --><!-- /ko -->
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                            <!-- /ko -->
                        </table>
                    </div>
                    <!-- ko if: subjects.length > 1 && subjects.filter((subject) => subject.drugQuantityApplied() === 0).length -->
                    <input type="number" class="tw:w-24" min="0" id="procedure-drug-quantity-to-apply" data-bind="css: {invalid_data: drugQuantityToApply.isInvalid},
                                      textInput: drugQuantityToApply">
                    <label class="tw:ps-1" for="procedure-drug-quantity-to-apply" data-bind="text: drugUnit">
                    </label>
                    <input type="button" class="tw:ml-1" data-bind="click: spreadDrugQuantityToAllSubjects,
                                      disable: drugQuantityToApply.isInvalid,
                                      value: translated('Drug quantity: Spread')">
                    <input type="button" class="tw:ml-1" data-bind="click: copyDrugQuantityToAllSubjects,
                                      disable: drugQuantityToApply.isInvalid,
                                      value: translated('Drug quantity: Assign')">
                    <!-- /ko -->
                </div>
            </div>
            <div class="tw:flex tw:gap-0.5 tw:py-0.5">
                <label for="procedure-drug-quantity-discarded" class="tw:w-36 tw:pt-0.5 nowrap" data-bind="text: translated('Drug quantity: Discarded (in total)') + ':'"></label>
                <div class="tw:w-9/12">
                    <input type="number" class="tw:w-32" placeholder="0" min="0" id="procedure-drug-quantity-discarded" data-bind="css: {invalid_data: drugQuantityDiscarded.isInvalid},
                                      value: drugQuantityDiscarded">
                    <span class="tw:ps-1" data-bind="text: drugUnit"></span>
                </div>
            </div>
            <!-- /ko -->

            <!-- ko ifnot: quickSelectActionId -->
            <div class="txt-end fake_popup_dialog tw:mb-2">
                <input type="button" class="confirm" data-bind="click: addProcedure,
                                  disable: !canSubmit(),
                                  value: translated('Add procedure')">
            </div>
            <!-- /ko -->
        </div>
        <!-- /ko -->
    </div>
    <!-- /ko -->

    <!-- ko if: currentProcedures !== undefined -->
    <div class="no_data_message" data-bind="visible: !currentProcedures.length,
                    text: translated('No procedures yet')"></div>

    <table class="simple-table zebra-style" data-bind="visible: currentProcedures.length">
        <thead>
            <tr>
                <!-- ko if: subjects.filter((subject) => "tank_id" in subject).map((subject) => subject.tank_id).length -->
                <th data-bind="text: translated('Tank')"></th>
                <!-- /ko -->
                <th data-bind="text: translated('User')"></th>
                <th data-bind="text: translated('Date')"></th>
                <th data-bind="text: translated('Procedure')"></th>
                <th data-bind="text: translated('License')"></th>
                <th data-bind="text: translated('Comment')"></th>
                <th class="tw:text-end" data-bind="click: toggleShowRemovedRows,
                               attr: {title: showRemovedRows() ? translated('Hide deleted procedures') : translated('Show deleted procedures')}">
                    <span class="tw:sr-only" data-bind="text: translated('Show all') / translated('Show valid')"></span>
                    <!-- ko if: !showRemovedRows() -->
                    <a class="icon_button icon_eye only_icon_img" data-bind="attr: {title: translated('Show all')}"></a>
                    <!-- /ko -->
                    <!-- ko if: showRemovedRows() -->
                    <a class="icon_button icon_delete only_icon_img" data-bind="attr: {title: translated('Show valid')}"></a>
                    <!-- /ko -->
                </th>
            </tr>
        </thead>
        <tbody data-bind="foreach: {data: currentProcedures, as: 'procedure'}">
            <tr data-bind="if: !procedure.canceled || \$parent.showRemovedRows(),
                           css: {delete: procedure.canceled}">
                <!-- ko if: \$parent.subjects.filter((subject) => "tank_id" in subject).map((subject) => subject.tank_id).length -->
                <td data-bind="text: procedure.tank_id"></td>
                <!-- /ko -->
                <td>
                    <span class="procedure_user" data-bind="text: procedure.actor_fullname"></span>
                    <span class="eventfooter tw:whitespace-nowrap" data-bind="visible: executed_by_id,
                                     attr: {title: translated('Executed by')},
                                     text: \`(\${procedure.executed_by_fullname})\`">
                    </span>
                    <span class="eventfooter tw:whitespace-nowrap" data-bind="attr: {title: translated('Edit time')},
                                     text: \`(\${utils.formatIsoDateTime(procedure.edit_time)})\`"></span>
                </td>
                <td data-bind="text: utils.formatIsoDate(procedure.procedure_date)"></td>
                <td>
                    <span data-bind="text: procedure.procedure_name" class="tw:break-words tw:text-balance breakable"></span>
                    <div data-bind="visible: procedure.drug_name">
                        <span data-bind="text: procedure.drug_quantity"></span>
                        <span data-bind="text: procedure.drug_unit_label"></span>
                        <span data-bind="text: procedure.drug_name"></span>
                        <!-- ko if: procedure.drug_package_number -->
                            <span data-bind="text: '(' + translated('Package number') + ': ' + procedure.drug_package_number + ')'"></span>
                        <!-- /ko -->
                    </div>
                </td>
                <td>
                    <span data-bind="text: procedure.license_number + ': ' + procedure.classification_name,
                                     visible: procedure.classification_name"></span>
                </td>
                <td data-bind="text: procedure.comment"></td>
                <!-- ko if: \$data.can_delete -->
                <td class="txt-center" data-bind="attr: {title: translated('Delete procedure')},
                               click: \$parent.removeProcedure">
                    <a class="icon_button icon_delete only_icon_img"></a>
                </td>
                <!-- /ko -->
                <!-- ko ifnot: \$data.can_delete -->
                <td class="w40"></td>
                <!-- /ko -->
            </tr>
        </tbody>
    </table>
    <!-- /ko -->
</div>
`;
// Exports
export default code;